export { VideoCaptureTutorial, type VideoCaptureTutorialProps } from './VideoCaptureTutorial';
